module.exports = __webpack_public_path__ + "static/thpcblueeleph1-754749ffce0c0bad6ee45a0ae5bc8972.jpeg";